module.exports = __webpack_public_path__ + "static/media/logo-white-hollow.e0329516.png";